import { SupplyInstructionOptions } from '@caresend/types';
import { formatFullName, formatDateOfBirth } from '@caresend/utils';
import { defineComponent, computed, ref, watch } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$2 from '../../../../../inputs/Checkbox.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import __vue_component__$1 from '../../../../SupplyLabel/SupplyLabel.vue.js';
import { initSuppliesToCheck } from '../../../../../../functions/supplies/init.js';

var script = defineComponent({
    name: 'ItineraryWaypointSampleChecklist',
    components: {
        BasicCard: __vue_component__,
        SupplyLabel: __vue_component__$1,
        Checkbox: __vue_component__$2,
    },
    model: {
        prop: 'labelsIncomplete',
        event: 'update:labelsIncomplete',
    },
    props: {
        procedureID: {
            type: String,
            required: true,
        },
        waypointActionID: {
            type: String,
            required: true,
        },
        waypointID: {
            type: String,
            required: true,
        },
        itineraryID: {
            type: String,
            required: true,
        },
    },
    emits: ['update:labelsIncomplete'],
    setup(props, { emit }) {
        var _a, _b;
        const { procedures } = usePortalStore();
        const procedure = computed(() => procedures.get(props.procedureID));
        const prescriberID = computed(() => { var _a; return (_a = procedure.value) === null || _a === void 0 ? void 0 : _a.computed.prescriberID; });
        const patient = computed(() => { var _a; return (_a = procedure.value) === null || _a === void 0 ? void 0 : _a.computed.patient; });
        const patientName = computed(() => formatFullName(patient.value));
        const patientDob = computed(() => { var _a; return formatDateOfBirth((_a = patient.value) === null || _a === void 0 ? void 0 : _a.info.dateOfBirth, 'MM/DD/YY'); });
        const suppliesToCheck = ref(initSuppliesToCheck(procedure.value, // Ignore the Workflows,
        (_b = (_a = procedures.get(props.procedureID)) === null || _a === void 0 ? void 0 : _a.computed.extendedSamples) !== null && _b !== void 0 ? _b : [], [SupplyInstructionOptions.DISCARD_AFTER_TRANSFER], 'samples'));
        const areSuppliesChecked = computed(() => suppliesToCheck.value.every((item) => item.isChecked));
        const checkSupply = (index, value) => {
            const supply = suppliesToCheck.value[index];
            if (!supply)
                return;
            supply.isChecked = value;
        };
        watch(areSuppliesChecked, (value) => value ? emit('update:labelsIncomplete', false) : emit('update:labelsIncomplete', true));
        return {
            patientName,
            patientDob,
            prescriberID,
            suppliesToCheck,
            checkSupply,
        };
    },
});

export { script as default };
